module.exports = __webpack_public_path__ + "media/coffee-preferences/coffee-quiz-73c05b40.png";